import React, {Component} from 'react';
import ReactTable from 'react-table';
import range from 'lodash/range';
import {
	Alert,
	Button,
	Card,
	CardBody,
	CardSubtitle,
	CardTitle,
	Col,
	Form,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalHeader,
	Row,
} from 'reactstrap';

import PaginationList from '../PaginationList/PaginationList';
import AttributesList from '../AttributesList/AttributesList';
import companyValidator from '../../helpers/companyValidator';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import {
	delCompany,
	fetchCompanies,
	fetchCompanyAvailableLanguages,
	updateSingleCompany
} from '../../actions/companyActions';
import {fetchCities, fetchCountries} from '../../actions/geoActions';
import {closeAlert} from '../../actions/commonsActions';
import {
	ACTIVE,
	BLOCKED,
	COMPANY_TYPES,
	DEV,
	GUEST,
	NOT_APPROVED,
	OPERATOR,
	PAGINATION_DEFAULT_LIMIT,
	PAGINATION_LIST_SIZE,
	RETAIL
} from '../../helpers/constants';
import {I18n} from '../../I18n/components/Companies';
import 'react-table/react-table.css';
import './companies.css';
import profilephoto from '../../assets/images/users/1.jpg';
import {updateCompanyAttributes} from '../../actions/attributesActions';
import Select from "react-select";
import CompanyTypeSelector from "../Company/CompanyTypeSelector";


class Companies extends Component {
	constructor(props) {
		super(props);
		this.state = {
			newCompany: {
				id: null,
				name: '',
				types: [],
				countryCode: '',
				cityGeonameId: '',
				languageId: 0,
				manager: '',
				phone: '',
				email: '',
				skype: '',
				status: ''
			},
			name: '',
			type: '',
			currentPage: 0,
			paginatedList: [],
			filters: [],
			modal: false,
			isOkModal: false,
			activeCompanyId: null,
			editMode: false,
			loading: false,

		};
		this.validators = companyValidator;
	}

	componentDidMount() {
		this.setState({
			loading: true
		}, () => {
			this.props.fetchCompanyAvailableLanguages();
			this.getGeo().then(() => {
				if (this.props.companies.length === 0 || this.props.companies.length === 1) {
					this.props.fetchCompanies(true).then(() => {
						this.setState({
							paginatedList: this.props.pagination.totalPages > PAGINATION_LIST_SIZE ?
								range(0, PAGINATION_LIST_SIZE) : range(0, this.props.pagination.totalPages),
							loading: false
						});
					})
				} else {
					this.setState({
						paginatedList: this.props.pagination.totalPages > PAGINATION_LIST_SIZE ?
							range(0, PAGINATION_LIST_SIZE) : range(0, this.props.pagination.totalPages),
						loading: false
					});
				}
			});
		})
	}

	componentDidUpdate(prevProps) {
		if (this.props.lang !== prevProps.lang) {
			(async () => {
				await this.props.fetchCompanyAvailableLanguages();
				await this.getGeo();
			})();
		}
	}

	getGeo = () => {
		return this.props.fetchCountries({
			lang: this.props.lang
		}).then(() => {
			return this.props.fetchCities({
				lang: this.props.lang,
				countryCode: this.props.companies[0].countryCode
			});
		}).catch(err => {
			console.error(err);
		});
	};

	getCompanyTypeName = value => {
		if (Array.isArray(value)) {
			return value.join(', ');
		}
		switch (value) {
			case RETAIL:
				return COMPANY_TYPES.RETAIL;
			case DEV:
				return COMPANY_TYPES.DEV;
			case OPERATOR:
				return COMPANY_TYPES.OPERATOR;
			default:
				return `${I18n[this.props.lang].noType}`;
		}
	};

	updateCountry = async data => { // get country and sities
		const selectedCountry = data.value;
		try {
			const cities = await this.props.fetchCities({
				lang: this.props.lang,
				countryCode: selectedCountry
			});
		} catch (err) {
			console.error(err);
		}
	};

	renderCountrySelect = () => {
		const options = this.props.countriesList.map(elem => (
			{value: elem.countryCode, label: elem.countryName}
		));
		let label = '';
		const activeCountry = this.props.countriesList.find(elem =>
			elem.countryCode === this.state.newCompany.countryCode
		);
		if (activeCountry) {
			label = activeCountry.countryName;
		}
		return (
			<Select
				name="countryCode"
				closeMenuOnSelect={true}
				value={{value: this.state.newCompany.countryCode, label: label}}
				options={options}
				onChange={data => {
					this.updateCountry(data);
					this.onInputChange(data);
				}}
				styles={{
					control: (styles, { data, isSelected }) => ({
						...styles,
						color: '#3e5569',
						backgroundColor: 'white',
						borderColor: '#e9ecef'
					}),
					singleValue: (styles, { data }) => ({
						...styles,
						color: '#3e5569'
					}),
				}}
			/>
		)
	};

	renderCitySelect = () => {
		const options = this.props.citiesList.map(elem => (
			{value: elem.geonameId, label: elem.name}
		));
		let label = '';
		const activeCity = this.props.citiesList.find(elem =>
			elem.geonameId === this.state.newCompany.cityGeonameId
		);
		if (activeCity) {
			label = activeCity.name;
		}
		return (
			<Select
				name="cityGeonameId"
				closeMenuOnSelect={true}
				value={{value: this.state.newCompany.cityGeonameId, label: label}}
				options={options}
				onChange={data => {
					this.onInputChange(data);
				}}
				styles={{
					control: (styles, { data, isSelected }) => ({
						...styles,
						color: '#3e5569',
						backgroundColor: 'white',
						borderColor: '#e9ecef'
					}),
					singleValue: (styles, { data }) => ({
						...styles,
						color: '#3e5569'
					}),
				}}
			/>
		)
	};

	renderCompanyLanguageSelect = () => {
		const options = this.props.companyLanguages.map(elem => (
			{value: elem.id, label: elem.name}
		));
		let label = '';
		const activeLanguage = this.props.companyLanguages.find(elem =>
			elem.id === this.state.newCompany.languageId
		);
		if (activeLanguage) {
			label = activeLanguage.name;
		}
		return (
			<Select
				name="languageId"
				closeMenuOnSelect={true}
				value={{value: this.state.newCompany.languageId, label: label}}
				options={options}
				onChange={data => this.onLanguageChange(data)}
				styles={{
					control: (styles, {data, isSelected}) => ({
						...styles,
						color: '#3e5569',
						backgroundColor: 'white',
						borderColor: '#e9ecef'
					}),
					singleValue: (styles, {data}) => ({
						...styles,
						color: '#3e5569'
					}),
				}}
			/>
		)
	};

	onFilterClick = name => {
		return event => {
			const value  = event.target.value;
			this.setState(state => {
				const filteredElemIndex = state.filters.findIndex(item => item.name === name);
				let filters = [...state.filters];
				if (filteredElemIndex !== -1) {
					if (value && value !== '') {
						filters[filteredElemIndex].name = name;
						filters[filteredElemIndex].value = value;
					} else {
						filters = filters.filter(elem => elem.name !== name);
					}
				} else {
					filters = [...state.filters, {name : name, value: value}]
				}
				return {
					[`${name}`]: value,
					filters: filters
				}
			}, () => {
				this.fetchPaginatedData(0);
			})
		}
	};

	clearFilters = () => {
		this.setState({
			name: '',
			type: '',
			filters: [],
			page: 0
		}, () => {
			this.fetchPaginatedData(0);
		})
	};

	fetchPaginatedData = async currentPage => {
		await this.props.fetchCompanies({
			filters: this.state.filters.length ? this.state.filters : false,
			page: currentPage
		});
		await this.setState({
			page: currentPage
		});
		/*this.setState({
			loading: true
		}, () => {
			this.props.fetchCompanies({
				filters: this.state.filters.length ? this.state.filters : false,
				page: currentPage
			}).then(() => {
				this.setState({
					loading: false
				})
			});
		});*/
	};

	setPaginatedList = paginatedList => {
		this.setState({
			paginatedList
		})
	};

	setCurrentPage = currentPage => {
		this.setState({
			currentPage
		});
		this.fetchPaginatedData(currentPage)
	};

	toggle = () => {
		this.setState({
			modal: !this.state.modal
		});
	};

	isOkModalToggle = id => {
		this.setState({
			isOkModal: !this.state.isOkModal,
			activeCompanyId: id
		});
	};

	deleteCompany = () => {
		let attributeIndex = this.props.companies.findIndex(elem => elem.id === this.state.activeCompanyId);
		if (attributeIndex >= 0) {
			this.props.delCompany(this.state.activeCompanyId).then(()=>{
				this.isOkModalToggle(null);
			});
		}
	};

	updateCompanyAttributesList = async attributes => {
        if (!attributes) {
            this.handleSubmit()
        } else {
            await this.props.updateCompanyAttributes(attributes);
            this.fetchPaginatedData(this.state.currentPage);
            setTimeout(() => {
                this.props.closeAlert();
            }, 3000);
        }
	};

	handleSubmit = event => {
		if(event) {
            event.preventDefault();
        }
		this.props.updateSingleCompany(this.state.newCompany)
			.then(company => {
					setTimeout(() => {
						this.props.closeAlert();
					}, 1000);
					this.clearNewCompanyState();
				}, error => {
					throw new Error(error.statusText)
				})
			.then(() => {
				this.fetchPaginatedData(0)
			})
	};

	clearNewCompanyState = () => {
		this.setState({
			newCompany: {
				id: null,
				name: '',
				types: [],
				countryCode: '',
				cityGeonameId: '',
				languageId: 0,
				manager: '',
				phone: '',
				email: '',
				skype: '',
				status: ''
			},
			activeCompanyId: null,
			editMode: false,
			cities:[],
		});
	};

	onInputChange = event => {
		let name, value;
		if (event && event.value && typeof event.value === "string") {
			name = 'countryCode';
			value = event.value;
		} else if (event && event.value && typeof event.value === "number") {
			name = 'cityGeonameId';
			value = event.value;
		} else {
			name = event.target.name;
			value = event.target.value;
		}
		this.setState(state => ({
			newCompany: Object.keys(state.newCompany).reduce((res, key) => {
				if (key === name) {
					// let tempValue = [];
					// if (Array.isArray(state.newCompany[key])) {
					// 	tempValue = value.split(',');
					// 	tempValue = tempValue.length === 1 && tempValue[0] === '' ? [] : tempValue;
					// } else {
					// 	tempValue = value;
					// }
					//res[key] = tempValue; //(Array.isArray(state.newAttribute[key])) ? value.split(',') : value;
					res[key] = value
				} else {
					res[key] = state.newCompany[key];
				}
				return res
			},{})
		}));
		this.formValidators([name], value);
	};

	onCompanyTypeChange = type => {
		const newCompany = {...this.state.newCompany};
		newCompany.types = type.value;
		this.setState({
			newCompany
		});
	};

	onLanguageChange = (event) => {
		const newCompany = {...this.state.newCompany};
		newCompany.languageId = event.value;
		this.setState({
			newCompany
		});
	};

	formValidators = (fieldName, value) => {
		this.validators[fieldName].errors = [];
		this.validators[fieldName].state = value;
		this.validators[fieldName].valid = true;
		this.validators[fieldName].rules.forEach(rule => {
			if (rule.test instanceof RegExp) {
				if (!rule.test.test(value)) {
					this.validators[fieldName].errors.push(rule.message);
					this.validators[fieldName].valid = false;
				}
			} else if (typeof rule.test === 'function') {
				if (!rule.test(value)) {
					this.validators[fieldName].errors.push(rule.message);
					this.validators[fieldName].valid = false;
				}
			}

		});
	};

	isFormValid = () => {
		let status = true;
		Object.keys(this.validators).forEach(field => {
			if (!this.validators[field].valid) {
				status = false;
			}
		});
		return status;
	};

	showErrors = fieldName => {
		const validator = this.validators[fieldName];
		const result = '';
		if (validator && !validator.valid) {
			const errors = validator.errors.map((info, index) => {
				return (
					<span className="error" key={index}>
           			 	* {info}
						<br/>
          			</span>
				);
			});

			return <div className="error mb-2">{errors}</div>;
		}
		return result;
	};

	renderList = () => {
		const { companies, lang } = this.props;
		let firstElementNumber = this.state.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
		const tableData = companies.map((company) => {
			return {
				count_id: firstElementNumber++,
				id: company.id,
				name: company.name,
				types: company.types || 'none',
				manager: company.manager,
				status: company.status,
				actions: (
					<div className="text-center">
						<Button
							onClick={() => {
								let selectedCompany = tableData.find(item => item.id === company.id)
								Object.keys(this.validators).forEach(elem => {
									this.validators[elem].errors = [];
									this.validators[elem].state = '';
									this.validators[elem].valid = true;
								});
								this.setState({
									modal: !this.state.modal,
									newCompany: selectedCompany,
									editMode: true,
								}, async () => {
									await this.props.fetchCities({
										lang: this.props.lang,
										countryCode: selectedCompany.countryCode
									});
								});
							}}
							color="inverse"
							size="sm"
							round="true"
							icon="true"
						>
							<i className="fa fa-edit"/>
						</Button>
						<Button
							onClick={() => {this.isOkModalToggle(company.id)}}
							className="ml-1"
							color="danger"
							size="sm"
							round="true"
							icon="true"
						>
							<i className="fa fa-times"/>
						</Button>
					</div>
				),
				countryCode: company.countryCode,
				cityGeonameId: company.cityGeonameId,
				languageId: company.languageId,
				phone: company.phoneNumber,
				email: company.email,
				skype: company.skype,
				attributes: company.attributes
			};
		});
		return (
			<div className="company-table">
				<ReactTable
					getProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								border: "none",
								padding: "5px"
							}
						};
					}}
					getTheadProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								boxShadow: "none",
								padding: "10px 0",
								fontWeight: "600"
							}
						};
					}}
					getTheadThProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								borderRight: "none"
							}
						};
					}}
					getTdProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								borderRight: "none",
								textAlign: "center"
							}
						};
					}}
					getTrProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								alignItems: "center"
							}
						};
					}}
					getNoDataProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								top: "100%"
							}
						};
					}}
					columns={[
						{
							Header: "#",
							accessor: "count_id",
							sortable: false,
							filterable: false,
							style: {
								textAlign: "left",
								fontSize: "0.7rem",
								textTransform: "lowercase"
							},
							maxWidth: 40,

						},
						{
							Header: `${I18n[lang].organisation}`,
							accessor: "name",
							sortable: false,
							filterable: false,
							minWidth: 200,
							style: {
								fontSize: "1.2rem",
								textAlign: "left"
							},
							Cell: row => (
								<div className="user-table__img">
									<img
										src={row.value.img ? row.value.img : profilephoto}
										alt="user"
										className="rounded-circle"
										width="60"
									/>
									<span>{row.value}</span>
								</div>
							)
						},
						{
							Header: `${I18n[lang].tableType}`,
							accessor: "types",
							sortable: false,
							filterable: false,
							maxWidth: 150,
							style: {
								fontSize: "0.7rem",
								textTransform: "lowercase"
							},
							Cell: row => (
								<span>
									{this.getCompanyTypeName(row.value)}
								</span>
							)
						},
						{
							Header: `${I18n[lang].manager}`,
							accessor: "manager",
							sortable: false,
							filterable: false,
							maxWidth: 250,
							style: {
								//textAlign: "left"
							}
						},
						{
							Header: `${I18n[lang].status}`,
							accessor: "status",
							sortable: false,
							filterable: false,
							maxWidth: 100,
							style: {
								fontSize: "0.7rem",
								textTransform: "lowercase",
							},
							Cell: row => (
								<span style={{
									background: row.value === BLOCKED ? '#f62d51'
										: row.value === NOT_APPROVED ? '#8898aa'
											: row.value === ACTIVE ? '#57D500' : '#000000',
									padding: "3px 5px",
									borderRadius: "45px",
									color: "#ffffff"
								}}>
								{
									row.value === BLOCKED ? `${I18n[lang].statusBlocked}` :
										row.value === NOT_APPROVED ? `${I18n[lang].statusPending}` :
											row.value === ACTIVE ? `${I18n[lang].statusActive}` : `${I18n[lang].noType}`
								}
								</span>
							)
						},
						{
							Header: "",
							accessor: "actions",
							sortable: false,
							filterable: false,
							maxWidth: 75
						}
					]}
					defaultPageSize={tableData.length}
					showPaginationBottom={false}
					className="-highlight"
					data={tableData}
					filterable
				/>
				<PaginationList
					totalPages={this.props.pagination.totalPages}
					currentPage={this.state.currentPage}
					paginatedList={this.state.paginatedList}
					setCurrentPage={this.setCurrentPage}
					setPaginatedList={this.setPaginatedList}
				/>
			</div>
		)
	};

	render() {
		const {lang} = this.props;
		const { loading } = this.state;
		console.log('loading', loading)

		return (
			<div className='companies '>
				{/*----------------------- alerts -----------------------------------*/}
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<Modal className="del-modal" isOpen={this.state.isOkModal} toggle={this.isOkModalToggle}>
					<ModalHeader>{I18n[lang].modal.sure}</ModalHeader>
					<ModalBody>
						<Button color="danger" className="ml-1" onClick={this.deleteCompany}>{I18n[lang].modal.delete}</Button>
						<Button color="secondary" className="ml-1" onClick={() => {this.isOkModalToggle(null)}}>{I18n[lang].modal.cancel}</Button>
					</ModalBody>
				</Modal>
				<Modal className="companies-modal" isOpen={this.state.modal} toggle={this.toggle}>
					<ModalHeader toggle={this.toggle}>{I18n[lang].modal.changeCompany}</ModalHeader>
					<ModalBody>
						<Row>
							<Col xs="12" md="12" lg="3">
								<Card>
									<CardBody>
										<div className="text-center mt-4">
											<img src={profilephoto} className="rounded-circle" width="150" alt="" />
											<CardTitle className="mt-2 user-modal__name">{this.state.newCompany.name}</CardTitle>
											<CardSubtitle>{this.state.newCompany.types || 'none'}</CardSubtitle>
										</div>
									</CardBody>
									<CardBody className="border-top">
										<div>
											<small className="text-muted">{I18n[lang].modal.email}</small>
											<h6>{this.state.newCompany.email}</h6>
											<small className="text-muted pt-4 db">{I18n[lang].modal.phone}</small>
											<h6>{this.state.newCompany.phone}</h6>
										</div>
									</CardBody>
								</Card>
							</Col>
							<Col xs="12" md="12" lg="9">
								<Card>
									<CardBody>
										<Form onSubmit={this.handleSubmit} className='new-attr__form'>
											<Row>
												<Col xs="12" md="12" lg="12">
													<Input type="hidden" name="id" id="id" defaultValue={this.state.newCompany.id} />
												</Col>
											</Row>
											<Row>
												<Col xs="12" md="12" lg="12">
													<FormGroup>
														<Label for="name">{I18n[lang].modal.companyTitle}</Label>
														<Input
															type="text"
															name="name"
															id="name"
															defaultValue={this.state.newCompany.name}
															onChange={this.onInputChange}
														/>
														{this.showErrors('name')}
													</FormGroup>
												</Col>
											</Row>
											<Row>
												<Col xs="12" md="12" lg="12">
													<FormGroup>
														<Label for="types">{I18n[lang].modal.type}</Label>
														{/*<Input*/}
														{/*	type="select"*/}
														{/*	name="types"*/}
														{/*	id="types"*/}
														{/*	defaultValue={this.state.newCompany.type}*/}
														{/*	onChange={this.onInputChange}*/}
														{/*>*/}
														{/*	<option value=""></option>*/}
														{/*	<option value={RETAIL}>{COMPANY_TYPES.RETAIL}</option>*/}
														{/*	<option value={DEV}>{COMPANY_TYPES.DEV}</option>*/}
														{/*</Input>*/}
														{/*{this.renderTypeSelect()}*/}
														<CompanyTypeSelector
															types={this.state.newCompany.types}
															lang={lang}
															onCompanyTypeChange={this.onCompanyTypeChange}
														/>
														{this.showErrors('types')}
													</FormGroup>
												</Col>
											</Row>
											<Row>
												<Col xs="12" md="12" lg="4">
													<FormGroup>
														<Label for="countryCode">{I18n[lang].modal.country}</Label>
														{this.renderCountrySelect()}
														{this.showErrors('countryCode')}
													</FormGroup>
												</Col>
												<Col xs="12" md="12" lg="4">
													<FormGroup>
														<Label for="cityGeonameId">{I18n[lang].modal.city}</Label>
														{this.renderCitySelect()}
														{this.showErrors('cityGeonameId')}
													</FormGroup>
												</Col>
												<Col xs="12" md="12" lg="4">
													<FormGroup>
														<Label for="languageId">{I18n[lang].modal.language}</Label>
														{this.renderCompanyLanguageSelect()}
													</FormGroup>
												</Col>
											</Row>
											<Row>
												<Col xs="12" md="12" lg="12">
													<FormGroup>
														<Label for="manager">{I18n[lang].modal.manager}</Label>
														<Input
															type="text"
															name="manager"
															id="manager"
															defaultValue={this.state.newCompany.manager}
															onChange={this.onInputChange}
														/>
														{this.showErrors('manager')}
													</FormGroup>
												</Col>
											</Row>
											<Row>
												<Col xs="12" md="12" lg="6">
													<FormGroup>
														<Label for="email">{I18n[lang].modal.mail}</Label>
														<Input
															type="text"
															name="email"
															id="email"
															defaultValue={this.state.newCompany.email}
															onChange={this.onInputChange}
														/>
														{this.showErrors('email')}
													</FormGroup>
												</Col>
												<Col xs="12" md="12" lg="6">
													<FormGroup>
														<Label for="types">{I18n[lang].modal.phone}</Label>
														<Input
															type="text"
															name="phone"
															id="phone"
															defaultValue={this.state.newCompany.phone}
															onChange={this.onInputChange}
														/>
														{this.showErrors('phone')}
													</FormGroup>
												</Col>
											</Row>
											<Row>
												<Col xs="12" md="12" lg="6">
													<FormGroup>
														<Label for="skype">{I18n[lang].modal.skype}</Label>
														<Input
															type="text"
															name="skype"
															id="skype"
															defaultValue={this.state.newCompany.skype}
															onChange={this.onInputChange}
														/>
														{this.showErrors('skype')}
													</FormGroup>
												</Col>
												<Col xs="12" md="12" lg="6">
													<FormGroup>
														<Label for="status">{I18n[lang].modal.status}</Label>
														<Input
															type="select"
															name="status"
															id="status"
															defaultValue={this.state.newCompany.status}
															onChange={this.onInputChange}
														>
															<option value=""></option>
															<option value={NOT_APPROVED}>{I18n[lang].modal.statusPending}</option>
															<option value={ACTIVE}>{I18n[lang].modal.statusActive}</option>
															<option value={BLOCKED}>{I18n[lang].modal.statusBlocked}</option>
														</Input>
													</FormGroup>
												</Col>
											</Row>
                                            {
                                                this.state.newCompany.attributes && this.state.newCompany.attributes.length ? "" : (
                                                    <Row>
                                                        <Col xs="12" md="12" lg="12">
                                                            <FormGroup className='new-attr__buttons'>
                                                                <Button color="secondary" className="ml-1" onClick={this.toggle}>{I18n[lang].modal.cancel}</Button>
                                                                <Button color="primary" className={`${
                                                                    this.isFormValid() ? '' : 'disabled'}`} type="submit">{I18n[lang].modal.save}</Button>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                )
                                            }
										</Form>
									</CardBody>
								</Card>
							</Col>
						</Row>
						<Card>
							<CardBody>
								{
									this.state.newCompany.attributes && this.state.newCompany.attributes.length ? (
										<div>
											<CardSubtitle>{I18n[lang].modal.companyAttributes}</CardSubtitle>
											<AttributesList
												attributes={this.state.newCompany.attributes ? this.state.newCompany.attributes : []}
												isAttributesChangingAllowed={true}
												updateAttributesList={this.updateCompanyAttributesList}
												authority={this.props.authority}
												closeModal={this.toggle}
												isTypeShown={true}
											/>
										</div>
									) : ""
								}
							</CardBody>
						</Card>
					</ModalBody>
				</Modal>
				<Card>
					<CardTitle className="mb-0 p-3 border-bottom bg-light">
						<div>
							<i className="mdi mdi-border-right mr-2"></i>{I18n[lang].companiesTitle}
						</div>
						{/*<Button color="primary" type="button" onClick={this.addAttributeClick}>Добавить атрибут</Button>*/}
					</CardTitle>

					<CardBody>
						<div className="companies-card companies-card_list">
							<div className="companies-card__left">
								<Form className="companies-searchform">
									<Input
										type="text"
										name="companiesSearch"
										id="companiesSearch"
										onChange={this.onFilterClick('name')}
										value={this.state.name}
										placeholder={I18n[lang].companyNamePlaceholder}
									/>
								</Form>
								{/*<Input
									className="companies-card__input"
									type="select"
									name="companiesStatus"
									id="companiesStatus"
									onChange={this.onFilterClick('status')}
									value="status">
									<option value="">{I18n[lang].status}</option>
									<option value={NOT_APPROVED}>{I18n[lang].statusPending}</option>
									<option value={ACTIVE}>{I18n[lang].statusActive}</option>
									<option value={BLOCKED}>{I18n[lang].statusBlocked}</option>
									{
										// attr.attribute.permittedValues ? (
										// 	attr.attribute.permittedValues.map((elem, i) => {
										// 		return (
										// 			<option value={elem} key={i}>{ elem }</option>
										// 		)
										// 	})
										// ) : (
										// 	<option></option>
										// )
									}
								</Input>**/}
								<Input
									className="companies-card__input"
									type="select"
									name="companiesType"
									id="companiesType"
									onChange={this.onFilterClick('type')}
									value={this.state.type}>
									<option value="">{I18n[lang].type}</option>
									<option value={RETAIL}>{I18n[lang].typeRetail}</option>
									<option value={DEV}>{I18n[lang].typeDev}</option>
                                    <option value={OPERATOR}>{I18n[lang].typeOperator}</option>
								</Input>
								<Button color="secondary" className="ml-1 userlist-card__btn" onClick={this.clearFilters}>{I18n[lang].clearFilters}</Button>
							</div>
							<div className="companies-card__right">
								<Button
									color="primary"
									type="button"
									className="userlist-card__btn"
									onClick={() => this.props.changeLocation('/dashboard/companies/add')}
								>
									{I18n[lang].addOrganisation}
								</Button>
							</div>
						</div>
						{
							loading ? (
								<div className="loading">Loading...</div>
							) : (
								this.renderList()
							)
						}
					</CardBody>
				</Card>
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		fetchCompanies: query => dispatch(fetchCompanies(query)),
		closeAlert: () => dispatch(closeAlert()),
		changeLocation: url => dispatch(push(url)),
		delCompany: companyId => dispatch(delCompany(companyId)),
		updateSingleCompany: company => dispatch(updateSingleCompany(company)),
		updateCompanyAttributes: attributes => dispatch(updateCompanyAttributes(attributes)),
		fetchCountries: query => dispatch(fetchCountries(query)),
		fetchCities: query => dispatch(fetchCities(query)),
		fetchCompanyAvailableLanguages: () => dispatch(fetchCompanyAvailableLanguages())
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	companies: state.companiesReducer.companies,
	pagination: state.companiesReducer.pagination,
	authority:  state.currentUser.roles[0].authority || GUEST,
	lang: state.languageReducer.lang,
	countriesList: state.countriesList.countries,
	citiesList: state.citiesList.cities,
	companyLanguages: state.companyLanguageReducer.companyLanguages
});

export default connect(mapStateToProps, mapDispatchToProps)(Companies)



// WEBPACK FOOTER //
// ./src/components/Companies/Companies.js